"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Year;
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _competitionsMenu = _interopRequireDefault(require("./competitions-menu"));
var _competitions = _interopRequireDefault(require("./competitions"));
var _myAccount = _interopRequireDefault(require("./my-account"));
var _multiCompetitionEntry = _interopRequireDefault(require("./multi-competition-entry"));
var _statistics = _interopRequireDefault(require("./statistics"));
var _calendarApplications = _interopRequireDefault(require("./calendar-applications"));
var _notFound = _interopRequireDefault(require("../not-found"));
var _constantParams = require("../../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_notFound.default, null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_notFound.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Year({
  match
}) {
  if (!/^[0-9]{4}$/.test(match.params.yearID)) {
    return _ref;
  }

  // Allow year to go one ahead of the current system year to allow for calendar applications and other prep for next season.
  if (+match.params.yearID < 2016 || +match.params.yearID > _constantParams.thisYear + 1) return _ref2;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: match.path + '/managed-calendar/my-applications',
    to: match.url + '/calendar-applications/my-applications'
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: false,
    from: match.path + '/managed-calendar',
    to: match.url + '/calendar-applications'
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: match.path,
    component: _competitionsMenu.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/competition/:competitionSlug',
    component: _competitions.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/calendar-applications',
    component: _calendarApplications.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/statistics',
    component: _statistics.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/my-account',
    component: _myAccount.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: match.path + '/multi-competition-entry',
    component: _multiCompetitionEntry.default
  }), _ref3);
}